// extracted by mini-css-extract-plugin
module.exports = {"symbolFill":"DisasterIcon__symbolFill___3rnvI","symbolStroke":"DisasterIcon__symbolStroke___3uUcS"};